import { CATEGORIES } from 'modules/Faq/config/categories'
import { ROUTES } from 'constants/routes'

const mapArticleToRoute = (genPath) => ({ slug: articleId, title }) => ({
  key: articleId,
  label: title,
  path: genPath(ROUTES.CABINET_FAQ_ARTICLE, { articleId }),
})

const mapCategoryToRoute = (genPath) => {
  const mapArticle = mapArticleToRoute(genPath)

  return function mapCategory({ slug: categoryId, title, articles = [], categories = [] }) {
    return {
      key: categoryId,
      label: title,
      path: genPath(ROUTES.CABINET_FAQ_CATEGORY, { categoryId }),
      routes: [...categories.map(mapCategory), ...articles.map(mapArticle)],
    }
  }
}

export const mapCategoriesToNavItems = (data, genPath) => {
  const mapCategory = mapCategoryToRoute(genPath)
  const mapArticle = mapArticleToRoute(genPath)

  return (
    data?.map(({ slug: categoryId, title, articles = [], categories = [] }) => ({
      key: categoryId,
      label: title,
      icon: CATEGORIES[categoryId]?.icon || null,
      routes: [...categories.map(mapCategory), ...articles.map(mapArticle)],
    })) ?? []
  )
}
